<ion-content>
  <div class="absolute right-4 top-8" (click)="location.back()">
    <ion-icon class="text-[42px]" name="close-outline"></ion-icon>
  </div>
  <div class="flex flex-col justify-center h-full">
    <div class="relative bg-white rounded-2xl px-6 pt-16 pb-4 shadow m-3">
      <img
        class="absolute top-0 h-[114px] left-[50%] -translate-x-1/2 -translate-y-3/4"
        style="filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))"
        src="/assets/logos/logo.svg" />
      <form [formGroup]="loginForm" novalidate class="flex flex-col gap-6">
        <h2 class="text-center">{{ 'ONBOARDING.LOGIN.TITLE' | transloco }}</h2>
        <ion-input
          fill="solid"
          formControlName="email"
          type="email"
          required
          inputmode="email"
          [placeholder]="'ONBOARDING.LOGIN.EMAIL' | transloco "
          [errorText]="'ERROR.REQUIRED' | transloco" />
        <ion-input
          fill="solid"
          formControlName="password"
          type="password"
          required
          [placeholder]="'ONBOARDING.LOGIN.PASSWORD' | transloco"
          [errorText]="'ERROR.REQUIRED' | transloco">
          <ion-input-password-toggle color="dark" slot="end"></ion-input-password-toggle>
        </ion-input>

        <div class="flex justify-center">
          <gt-button size="xl" (click)="doLogin()">{{ 'ONBOARDING.LOGIN.LOGIN' | transloco }}</gt-button>
        </div>
        <div class="text-center" [routerLink]="['../forgot']">{{ 'ONBOARDING.LOGIN.FORGOT' | transloco }}</div>
      </form>
    </div>
  </div>
</ion-content>
